<template>
  <v-dialog
    v-model="sendEmailDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="50%"
    persistent
  >
    <v-card>
      <v-toolbar
        dark
        color="secondary"
        class="elevation-0"
      >
        <v-btn
          icon
          dark
          @click.native="sendEmailDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>שליחת אי-מייל</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="loading"
          :disabled="loading"
          @click="sendEmail"
        >
          שליחה
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-select
          :items="emailTypes"
          label="סוג אי-מייל"
          item-text="title"
          item-value="_id"
          v-model="editable.emailType"
          clearable
        ></v-select>
        <v-select
          :items="customers"
          label="לקוח"
          item-text="name"
          item-value="_id"
          @input="setEmailField"
          v-model="editable.customer"
          clearable
        ></v-select>
        <v-text-field
          label="כתובת אי-מייל"
          v-model="editable.emailAddress"
          :disabled="!!editable.customer"
        ></v-text-field>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApi } from "@/api";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      loading: false,
      editable: {}
    };
  },

  computed: {
    sendEmailDialog: {
      get() {
        return this.$store.state.sendEmailDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_SEND_EMAIL_DIALOG", isActive);
      }
    },
    order() {
      return this.$store.state.entities.orders[this.orderId];
    },
    emailTypes() {
      return Object.values(this.$store.state.entities.emailTypes);
    },
    customers() {
      let customers = [];
      if (this.order) {
        let traveler = this.customerById(this.order.traveler);
        let payer = this.customerById(this.order.payer);
        if (traveler) {
          customers.push(traveler);
        }
        if (payer) {
          customers.push(payer);
        }
      }
      return customers;
    }
  },

  methods: {
    sendEmail() {
      this.loading = true;

      getApi()
        .then(api => {
          let params = {
            order: this.orderId,
            emailAddress: this.editable.emailAddress
          };
          return api.post(
            `/email-types/${this.editable.emailType}/send`,
            params
          );
        })
        .then(() => {
          this.sendEmailDialog = false;
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "האי-מייל נשלח בהצלחה",
            color: "success"
          });
        })
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initEditableResource() {
      this.editable = {
        customer: null,
        emailType: null,
        emailAddress: null
      };
    },
    customerById(id) {
      return this.$store.state.entities.customers[id];
    },
    setEmailField(customerId) {
      if (customerId) {
        let customer = this.customerById(customerId);
        if (customer) {
          let email = customer.email;
          if (email) {
            this.editable.emailAddress = email;
          } else {
            this.editable.emailAddress = "";
            this.showError(new Error("לא הוזן אי-מייל ללקוח"));
          }
        }
      }
    }
  },

  mounted() {
    this.initEditableResource();
  },

  props: ["orderId"],

  mixins: [Mixins],

  watch: {
    sendEmailDialog: {
      handler: function(val) {
        if (!val) {
          this.initEditableResource();
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
